export default __webpack_public_path__ + "static/media/img_plus.26891ae0.svg";